import { render, staticRenderFns } from "./ListDoubleRegistration.vue?vue&type=template&id=53446a18&"
import script from "./ListDoubleRegistration.vue?vue&type=script&lang=js&"
export * from "./ListDoubleRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ListDoubleRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports